module.exports = __webpack_public_path__ + "img/leftTopLine.9a987805.png";